import { Grid } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';

import styles from 'assets/jss/Crm';
import { useEffect } from 'react';
import CrmHelpButton from '../Buttons/CrmHelpButton';
const useStyles = makeStyles(styles);

const Crm = ({ setShowCrm }) => {

    const classes = useStyles();

    const handlePopstate = (event) => {
        event.preventDefault();
        setShowCrm(false);
    };

    useEffect(() => {
        window.history.pushState(null, null, window.location.href);
        window.addEventListener('popstate', handlePopstate);
        return () => {
            window.removeEventListener('popstate', handlePopstate);
        };
    }, []);

    return (
        <Grid container justifyContent={'center'} xs={12} display='flex' >
            <p className={classes.textStyle}>در صورت وجود هرگونه مشکل در<br /> ورود یا ثبت نام؛ با کارشناسان واحد آموزش و ارتباط شرکت فریر آسا طب تماس بگیرید:</p>
            <Grid container xs={12}>
                <Grid item justifyContent={'center'} xs={12} mb='25px'><CrmHelpButton /></Grid>
                <Grid item xs={12} mb='66px' justifyContent={'center'} alignItems='center'>
                    <div className={classes.input}>
                        <div className={classes.number} dir='ltr'>۰۲۱ - ۲۴۸۳۷۰۰۰
                        </div>
                    </div>
                </Grid>
                <Grid item xs={12} mb={4}>
                    <div className={classes.back} onClick={() => setShowCrm(false)} >
                        <span onClick={() => setShowCrm(false)} className={classes.backText}>بازگشت</span>
                    </div>
                </Grid>
            </Grid>
        </Grid>
    );
};

export default Crm;;